import { render, staticRenderFns } from "./EntrepreneurQuote.vue?vue&type=template&id=bc1cfdca&scoped=true&"
import script from "./EntrepreneurQuote.vue?vue&type=script&lang=js&"
export * from "./EntrepreneurQuote.vue?vue&type=script&lang=js&"
import style0 from "./EntrepreneurQuote.vue?vue&type=style&index=0&id=bc1cfdca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1cfdca",
  null
  
)

export default component.exports